export default class extends Controller {

  connect() {
    App.Helpers.listenToCustomEvent(document, 'update-success', () => location.reload());
  }
};



// WEBPACK FOOTER //
// ./app/components/priorities/assets/javascript/priorities-index-controller.js